import { updateView, viewParams } from './update-view.js'

export function showTableGroupAllContacts (groupContactsResponse, entities) {
  console.log('showTableGroupAllContacts', groupContactsResponse)

  viewParams.groupContactsResponse = groupContactsResponse
  viewParams.entities = entities
  updateView()
}
